export function cagrCalc(initial, final, years) {
  if (initial <= 0 || final <= 0 || years <= 0) return null;
  return Math.pow(final / initial, 1 / years) - 1;
}

export function simpleReturnCalc(invested, current) {
  const gain = current - invested;
  return { gain, pct: invested > 0 ? gain / invested : null };
}

export function xirrCalc(flows) {
  const fs = flows
    .filter((f) => f.date && f.amount !== "" && Number(f.amount) !== 0)
    .map((f) => ({ d: new Date(f.date).getTime(), a: Number(f.amount) }));
  if (fs.length < 2 || !fs.some((f) => f.a < 0) || !fs.some((f) => f.a > 0)) return null;
  fs.sort((x, y) => x.d - y.d);
  const d0 = fs[0].d;
  const npv = (r) => fs.reduce((s, f) => s + f.a / Math.pow(1 + r, (f.d - d0) / (365.25 * 86400000)), 0);
  let lo = -0.9999, hi = 10;
  const flo = npv(lo);
  if (flo * npv(hi) > 0) return null;
  for (let i = 0; i < 200; i++) {
    const mid = (lo + hi) / 2;
    const fm = npv(mid);
    if (Math.abs(fm) < 1e-7) return mid;
    if (flo * fm < 0) hi = mid; else lo = mid;
  }
  return (lo + hi) / 2;
}

export function sipCalc(amount, freqPerYear, annualRatePct, years) {
  const n = Math.max(1, Math.round(freqPerYear * years));
  const i = annualRatePct / 100 / freqPerYear;
  const invested = amount * n;
  const value = i === 0 ? invested : amount * ((Math.pow(1 + i, n) - 1) / i) * (1 + i);
  return { invested, value, growth: value - invested };
}

export function compoundCalc(principal, annualRatePct, freqPerYear, years) {
  const value = principal * Math.pow(1 + annualRatePct / 100 / freqPerYear, freqPerYear * years);
  return { value, growth: value - principal };
}
